import Icon from '../../components/Icon.vue'

Icon.register({
  'brands/adn': {
    width: 496,
    height: 512,
    paths: [
      {
        d: 'M248 167.5l64.9 98.8h-129.8zM496 256c0 136.9-111.1 248-248 248s-248-111.1-248-248 111.1-248 248-248 248 111.1 248 248zM396.2 338.7l-148.2-223.2-148.2 223.2h30.4l33.6-51.7h168.6l33.6 51.7h30.2z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/brands/adn.js
// module id = 696
// module chunks = 0